<script>
export default {
  props: {
    errorMessage: { type: String },
    successMessage: { type: String },
    validationErrors: { type: Array },
  },
  data() {
    return {
      alert: null,
      alertTextAlign: "center",
    };
  },
  computed: {
    hasAlert() {
      return !_.isEmpty(this.alert);
    },
  },
  watch: {
    errorMessage(val) {
      this.showAlert("danger", val);
    },
    successMessage(val) {
      this.showAlert("success", val);
    },
    validationErrors(val) {
      this.parseErrors(val);
      this.alertTextAlign = "left";
    },
  },
  methods: {
    showAlert(type, message, autoHide, align) {
      this.alert = null;
      this.alert = {
        type: type,
        message: message,
        align: align || "center",
      };
      if (autoHide)
        setTimeout(() => {
          this.hideAlert();
        }, 3000);
    },
    hideAlert() {
      this.alert = null;
    },
    parseErrors(errors) {
      if ((_.isArray(errors) || _.isObject(errors)) && !_.isEmpty(errors)) {
        var message = "";
        message += "<p>The following error(s) occurred...</p>";
        message += "<ul class='mb-0'>";
        message += this.generateErrorListItems(errors);
        message += "</ul>";
        this.showAlert("danger", message, false, "left");
      }
    },
    generateErrorListItems(errors) {
      var items = "";
      for (var i in errors) {
        var error = errors[i];
        if (_.isArray(error)) {
          items += this.generateErrorListItems(error);
        } else {
          items += `<li>${error}</li>`;
        }
      }
      return items;
    },
  },
  mounted() {
    if (this.errorMessage) {
      this.showAlert("danger", this.errorMessage);
    } else if (this.successMessage) {
      this.showAlert("success", this.successMessage);
    } else if (this.validationErrors) {
      this.parseErrors(this.validationErrors);
    }
  },
};
</script>